import React from 'react';
import SharedTrainPandaArt from './SharedTrainPandaArt';

export default function TrainEngineArt({ premium = false }) {
  if (premium) return <SharedTrainPandaArt />;
  return <svg className="train-engine" data-train-art="classic" viewBox="0 0 190 200" aria-hidden="true">
    <ellipse cx="145" cy="25" rx="17" ry="11" fill="#ddd6fe" />
    <ellipse cx="161" cy="8" rx="11" ry="7" fill="#ede9fe" />
    <rect x="118" y="46" width="24" height="45" rx="4" fill="#7c3aed" />
    <rect x="111" y="41" width="38" height="13" rx="5" fill="#9b73f0" />
    <path d="M17 78H85V149H17Z" fill="#8056d9" stroke="#6237af" strokeWidth="4" />
    <rect x="9" y="66" width="84" height="17" rx="7" fill="#ad8bed" />
    <rect x="30" y="87" width="42" height="39" rx="8" fill="#d9f3ff" stroke="#c4b5fd" strokeWidth="5" />
    <path d="M87 97H146Q166 97 166 117V147H87Z" fill="#e9aa4c" stroke="#d28b2c" strokeWidth="4" />
    <circle cx="158" cy="110" r="10" fill="#ffeaad" stroke="#d28b2c" strokeWidth="3" />
    <path d="M164 133L183 164H159Z" fill="#9370e0" />
    <rect x="9" y="143" width="161" height="15" rx="5" fill="#563492" />
    {[41, 111, 146].map((x) => <g key={x}><circle cx={x} cy="168" r="20" fill="#523974" /><circle cx={x} cy="168" r="11" fill="#f5ddae" /><circle cx={x} cy="168" r="4" fill="#9e7bb5" /></g>)}
    <path d="M39 168H145" stroke="#b7a0d7" strokeWidth="5" strokeLinecap="round" />
  </svg>;
}
